import React from "react";
import { Form } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import ValidationHelper from "../../../../../../helpers/ValidationHelper";
import CamplaCoreService from "../../../../../../services/CamplaCoreService";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";
import BaseSelect from "../../../../../../components/baseSelect/BaseSelect";

class CreateTemplateScriptDialog extends React.Component {
  constructor(props) {
    super(props);

    this.semesterOptions = [
      { value: "spring", label: "ModuleClasses.SemesterSpring" },
      { value: "fall", label: "ModuleClasses.SemesterFall" }
    ];

    this.validationDefinition = {
      scriptId: {
        defaultValue: "",
        rule: ValidationHelper.isID
      }
    };

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition)
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation)
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.show !== this.props.show) {
      this.setState({
        validation: ValidationHelper.getValidation(this.validationDefinition)
      });
    }
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      this.props.onSubmit(validatedData);
    }
  }

  render() {
    const { t } = this.props;
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        rightButtonCallback={this.onSubmit}
        title={t("SingleInstanceTemplate.ScriptsTab.CreateModal.Title")}
        dialogApiError={this.props.dialogApiError}
        leftButtonText={t("DialogCancel")}
        leftButtonVariant="black"
        leftButtonCallback={this.onHide}
        rightButtonText={t("SingleInstanceTemplate.ScriptsTab.CreateModal.Form.Submit")}
        rightButtonVariant="green"
        rightButtonDisabled={!this.state.validation._isValid}
        body={(<Form onSubmit={this.onSubmit}>
          <Form.Group controlId="formBasicModules">
            <Form.Label>
              {t(
                "SingleInstanceTemplate.ScriptsTab.CreateModal.Form.ScriptSelection"
              )}
            </Form.Label>
            <BaseSelect
              options={
                this.props.unassociatedScripts?.map(s => {
                  return { label: s.name, value: s._id };
                }) || []
              }
              placeholder={t(
                "SingleInstanceTemplate.ScriptsTab.CreateModal.Form.ScriptSelectionPlaceholder"
              )}
              onChange={s =>
                this.handleChange({
                  target: {
                    name: "scriptId",
                    value: s.value
                  }
                })
              }
            />
            <Form.Control
              type="hidden"
              isInvalid={!this.state.validation.scriptId.isValid}
            />
            <Form.Control.Feedback type="invalid">
              {t(
                "SingleInstanceTemplate.ScriptsTab.CreateModal.Form.ValidationError.ScriptSelection"
              )}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>)}
      />
    );
  }
}

export default withTranslation()(CreateTemplateScriptDialog);
